module.exports = __webpack_public_path__ + "fonts/inter/inter-v20-latin-700.woff2";